import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../../src/environments/environment';
import {ReactiveServiceWithFilters} from '../reactive-service-with-filters.abstract';
import {Oauth2Model} from './oauth2.model';
import {of} from 'rxjs/internal/observable/of';
import {extractDomain} from '../../../../src/app/shared/helpers/domain.helper';

@Injectable( {providedIn: 'root'})
export class Oauth2sApiService extends ReactiveServiceWithFilters implements Resolve<any[]> {
  protected baseUrl = environment.backEndUrlPrefix + '/oauth2provider';

  constructor(private http: HttpClient) {
    super();
  }

  deleteGroup(ids: number[]): Observable<string> {
    return this.http.delete<string>(this.baseUrl, {params: {id: ids.map(id => String(id))}});
  }

  get(id): Observable<Oauth2Model> {
    return this.http.get<Oauth2Model>(`${environment.backEndUrlPrefix}/oauth2provider/${id}`);
  }

  getAll(param?: string) {
    const url = this.baseUrl + (param ? param : '');
    if ((param + '').indexOf('available') >= 0) {
      /* SEM-5241: нужно добавлять домен только для available параметра */
      return this.http.get<Oauth2Model[]>(url, {params: {domain: extractDomain(document.location.href + '')}});
    }
    return this.http.get<Oauth2Model[]>(url);
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any[]> | Promise<any[]> | any[] {
    if (route && route.data && route.data.breadcrumb === 'OAUTH2.PROVIDERS') {
      return this.getAll();
    } else if (window.location.href.indexOf('/#!/login?client_id') !== -1) {
      return of([]);
    } else if (window.location.href.indexOf('/#!/login') !== -1) {
      return this.getAll('/available');
    } else if (route && (route.component as any).name === 'LoginFormComponent') {
      return this.getAll('/available');
    }
    return this.getAll();
  }


}
